var map = {
	"./after1.jpg": "3861",
	"./after2.jpg": "b825",
	"./after3.jpg": "181c",
	"./after4.jpg": "7f62",
	"./after5.jpg": "2f47",
	"./before1.jpg": "c50f",
	"./before2.jpg": "f9a3",
	"./before3.jpg": "8add",
	"./before4.jpg": "e82b",
	"./before5.jpg": "9666"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05a1";